import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getMinAmountToStake } from '../services/createHPoolService';
import { getUserStaketsRequest } from '../services/hpoolService';
import { divideOnWei } from '../utils/mapper';
import { usePromise } from './usePromise/usePromise';

export const useUserStakes = (passedNftWeb3Id) => {
  const [getUserStakes, userStakes, loading] = usePromise(getUserStaketsRequest);
  const account = useSelector(({ wallet }) => wallet.account);

  const [, _minToStackRes] = usePromise(getMinAmountToStake, { initReq: true });
  const minToStack = useMemo(() => divideOnWei(_minToStackRes), [_minToStackRes]);

  const fetchInfo = () => {
    if (!account || !passedNftWeb3Id) return;
    getUserStakes(account, passedNftWeb3Id);
  };

  useEffect(() => {
    fetchInfo();
  }, [account, passedNftWeb3Id]);

  const {
    0: _hordStaked = [],
    1: tikcetsMintedArray = [],
    2: stakingDateArray = [],
    3: isWithdrawnArray = [],
  } = userStakes || {};

  const formatDate = (dateInMs = 0) => dateInMs * 1000;
  const parseStakedHord = (value = 0) => divideOnWei(+value);
  const formattedStakingDateArray = stakingDateArray?.map(formatDate);

  const totalHordStaked = _hordStaked.map(parseStakedHord).reduce((prev, current) => +prev + +current, 0);
  const totalTikcetsMinted = tikcetsMintedArray.reduce((prev, current) => +prev + +current, 0); // All reserved ticket (ones that has been withdrawn is included)

  const mergedInfo = tikcetsMintedArray.map((ticketsMinted, index) => ({
    ticketsMinted,
    stakingDate: formattedStakingDateArray?.[index],
    isWithdrawn: isWithdrawnArray?.[index],
    hordStaked: totalHordStaked,
  }));

  const unWithdrawnRecords = mergedInfo.filter((info) => !info.isWithdrawn);
  const currentTotalTicketsStacked = unWithdrawnRecords // tikcets that is not withdrawn
    .map((record) => record.ticketsMinted)
    .reduce((prev, current) => +prev + +current, 0);

  const totals = {
    totalHordStaked: currentTotalTicketsStacked * minToStack,
    totalTikcetsMinted: currentTotalTicketsStacked,
    numberOfAllTicketsReserved: totalTikcetsMinted,
  };
  return [mergedInfo, totals, loading, fetchInfo];
};
